import {
	ConfiguredCarFeatureType,
	StatusFragment,
	TypedConfiguredCarCatalogImages,
} from '~/graphql/__generated__/graphql';

type GroupableItem = {
	group: {
		id: string;
		name: string;
		/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
		__typename: any;
	};
	family: {
		id: string;
		name: string;
		/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
		__typename: any;
	};
	name?: string | null | undefined;
	imageSets?: Array<TypedConfiguredCarCatalogImages> | null | undefined;
	pr7: string; // | null | undefined;
	pr3?: string;
	featureType: ConfiguredCarFeatureType;
	status: StatusFragment;
	/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
	__typename: any;
};

export type Family<T extends GroupableItem> = {
	id: string;
	name?: string;
	items: T[];
};
export type Group<T extends GroupableItem> = {
	id: string;
	name?: string;
	families: Family<T>[];
	pr3?: string;
	featureType?: string;
	status?: StatusFragment | null | undefined;
};

export function groupItemsByGroupAndFamily<T extends GroupableItem>(items: T[]): Group<T>[] {
	return items.reduce<Group<T>[]>((acc, item) => {
		const groupIndex = acc.findIndex((group) => group.id === item.group.id);

		if (groupIndex === -1) {
			acc.push({
				id: item.group.id,
				name: item.group.name,
				families: [],
			});
		}

		const groupIdx = groupIndex === -1 ? acc.length - 1 : groupIndex;

		const familyIndex = acc[groupIdx].families.findIndex((family) => family.id === item.family.id);

		if (familyIndex === -1) {
			acc[groupIdx].families.push({
				id: item.family.id,
				name: item.family.name,
				items: [],
				__typename: 'Family',
			} as Group<T>['families'][0]);
		}

		const familyIdx = familyIndex === -1 ? acc[groupIdx].families.length - 1 : familyIndex;

		acc[groupIdx].families[familyIdx].items.push(item);

		return acc;
	}, []);
}
